/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ChangesGroupDto } from './ChangesGroupDto';
import {
    ChangesGroupDtoFromJSON,
    ChangesGroupDtoFromJSONTyped,
    ChangesGroupDtoToJSON,
} from './ChangesGroupDto';
import type { PropertyChangeSectionDtoTitle } from './PropertyChangeSectionDtoTitle';
import {
    PropertyChangeSectionDtoTitleFromJSON,
    PropertyChangeSectionDtoTitleFromJSONTyped,
    PropertyChangeSectionDtoTitleToJSON,
} from './PropertyChangeSectionDtoTitle';

/**
 * 
 * @export
 * @interface PropertyChangeSectionDto
 */
export interface PropertyChangeSectionDto {
    /**
     * 
     * @type {PropertyChangeSectionDtoTitle}
     * @memberof PropertyChangeSectionDto
     */
    title?: PropertyChangeSectionDtoTitle | null;
    /**
     * 
     * @type {Array<ChangesGroupDto>}
     * @memberof PropertyChangeSectionDto
     */
    changesGroup?: Array<ChangesGroupDto> | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyChangeSectionDto
     */
    $type?: PropertyChangeSectionDtoTypeEnum;
}


/**
 * @export
 */
export const PropertyChangeSectionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedEntityHistoryPropertyChangeSectionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.EntityHistory.PropertyChangeSectionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PropertyChangeSectionDtoTypeEnum = typeof PropertyChangeSectionDtoTypeEnum[keyof typeof PropertyChangeSectionDtoTypeEnum];


/**
 * Check if a given object implements the PropertyChangeSectionDto interface.
 */
export function instanceOfPropertyChangeSectionDto(value?: unknown): value is PropertyChangeSectionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PropertyChangeSectionDtoTypeEnum)[0];
}

export function PropertyChangeSectionDtoFromJSON(json: any): PropertyChangeSectionDto {
    return PropertyChangeSectionDtoFromJSONTyped(json, false);
}

export function PropertyChangeSectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyChangeSectionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : PropertyChangeSectionDtoTitleFromJSON(json['title']),
        'changesGroup': !exists(json, 'changesGroup') ? undefined : (json['changesGroup'] === null ? null : (json['changesGroup'] as Array<any>).map(ChangesGroupDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function PropertyChangeSectionDtoToJSON(value?: PropertyChangeSectionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'title': PropertyChangeSectionDtoTitleToJSON(value.title),
        'changesGroup': value.changesGroup === undefined ? undefined : (value.changesGroup === null ? null : (value.changesGroup as Array<any>).map(ChangesGroupDtoToJSON)),
        '$type': value.$type,
    });
}

